import { IService } from './IService';
import { ResourceWrapperService } from './utilities/ResourceWrapperService';

import IAngularEvent = angular.IAngularEvent;

export abstract class Service<T> implements IService {

  public items: T[];
  public itemResource: any;
  public readonly resource: angular.resource.IResourceService;
  public readonly rootScope: IRootScope;
  public readonly filter: angular.IFilterService;
  public readonly resourceWrapperService: ResourceWrapperService;

  protected constructor({
                        resource,
                        rootScope,
                        filter,
                        resourceWrapperService
                      }: { resource: angular.resource.IResourceService, rootScope?: IRootScope, filter?: angular.IFilterService, resourceWrapperService?: ResourceWrapperService }) {
    this.resource = resource;
    this.rootScope = rootScope;
    this.filter = filter;
    this.resourceWrapperService = resourceWrapperService;
    this.items = [];
  }

  public HasCache(id: string): boolean {
    return _.contains(this.items, _.findWhere(this.items, {id: id}));
  }

  public AsResource(item: T): any {
    return new this.itemResource(angular.copy(item));
  }

  public Create(item: T): any {
    return new this.itemResource(item);
  }

  public Save(item: T | any) {
    const resource = item["$save"] ? item as any : this.AsResource(item as T);

    return resource.$save(item => {
      this.items = _.without(this.items, _.findWhere(this.items, {id: item.id}));

      this.items.unshift(item);
      item.projectId && this.StartNotification(item.projectId);
    });
  }

  public Update(item: T | any) {
      const resource = item["$update"] ? item as any : this.AsResource(item as T);

      return resource.$update();
    }

  public GetCachedItems(): Array<T> {
      return [...this.items];
    }

  public ClearCachedItems() {
      this.items = [];
    }

  public async FindAll(params?: IParams) {
      const items = await this.itemResource.query(params ? {projectId: params.projectId} : {}).$promise;
      const results = new Array<T>();
      this.items.length = 0;

      return items.map(item => {
        this.FindMethodCustomProcessing(item);
        return item.toJSON();
      });
    }

  public async FindOne(params: IParams, cachingEnabled = true) {
      if (cachingEnabled && this.HasCache(params.id)) {
        return _.findWhere(this.items, {id: params.id}).toJSON();
      } else if (this.itemResource) {
        return await this.LoadOne(params);
      }

      return null;
    }

  public async LoadOne(params: IParams) {
      const item = await this.itemResource.get({id: params.id, projectId: params.projectId}).$promise;

      this.FindMethodCustomProcessing(item);

      return item;
    }

  public async FindSelected(projectId: string) {
      return this.filter('filter')(await this.FindAll({id: '', projectId: projectId}), {checked: true});
    }

  public async FindSelectedOrAll(projectId: string) {
      const items = await this.FindAll({id: '', projectId: projectId});
      let filtered = this.filter('filter')(items, {checked: true});

      if (_.isEmpty(filtered)) {
        return items;
      }

      return filtered;
    }

  protected FindMethodCustomProcessing(item) {
    }

  protected StartNotification(projectId: string) {
    }

  protected RegisterUpdateEventListener(eventName: string, handler: (e: angular.IAngularEvent, message: any) => Promise<T>) {
      const handlerWrapper = async (e: IAngularEvent, message) => {
        const item = await handler(e, message);

        const existing = _.findWhere(this.items, {id: item.id});

        if (!existing && this.itemResource) {
          this.items.push(this.AsResource(item));
        }

        if (item.job.percentageComplete >= 100) {
          return;
        }


        this.rootScope.$broadcast('MonitorableUpdated', item);
      };

      this.rootScope.$on(eventName, handlerWrapper);
    }

  protected RegisterCompleteEventListener(eventName: string, handler: (e: IAngularEvent, message) => Promise<T>) {
      let handlerWrapper = async (e: angular.IAngularEvent, message: any) => {
        const item = await handler(e, message);

        if (item) {
          this.rootScope.$broadcast('MonitorableCompleted', item);
        }
      };

      this.rootScope.$on(eventName, handlerWrapper);
    }
}

